export const test = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  names: [],
  countries: [],
  ids: [],
  sort: {
    key: 'createdAt',
    order: -1,
  },
  filter: {
    id: '',
    externalId: '',
    name: '',
    videoExistence: '',
    cityExistence: '',
    country: '',
    platform: '',
    active: '',
  },
};

export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  names: [],
  countries: [],
  ids: [],
  sort: {
    key: 'createdAt',
    order: -1,
  },
  filter: {
    id: '',
    externalId: '',
    name: '',
    videoExistence: '',
    cityExistence: '',
    country: '',
    platform: '',
    active: '',
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/campaignsByCountry.state.js
 **/